import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import SubTitle from '../Components/SubTitle';
import Loading from './Loading';
import axios from 'axios';
import ProductShow from '../Components/ProductShow';
import { URL } from '../config';

const MainCategoryProducts = () => {
    const [titles,setTitles]=useState([])
    const param=useParams();
    const MainCategoryId=param.MainCategoryId;
    const MainCategoryName=param.MainCategoryName;
    const [products,setProducts]=useState([]);
    const [nextPage,setNextPage]=useState('');
    const [path,setPath]=useState('');
    const [load,setLoad]=useState(false);

    useEffect(()=>{
        setTitles([{name:'MainCategoryName',link:''}]);
        setLoad(true);
        axios.get(`${URL}/api/product/get_main_category_products/${MainCategoryId}`)
        .then(function (response) {
          if(response.data.success){
            setProducts(response.data.data.data);
            setNextPage(response.data.data.next_page_url);
            setPath(response.data.data.path);
          }
          setLoad(false);
            })
        .catch(function (error) {
          console.log('error');
          setLoad(false);
        });
        setTitles([{name:MainCategoryName,link:''}]);
      },[MainCategoryId])
if(load)
    return <Loading/>
  return (

    <div className='container-fluid mt-lg-5 pt-5 mb-2'>
        <SubTitle titles={titles}/>
        <ProductShow products={products} nextPage={nextPage} nextPath={path} titles={titles}/>
    </div>
  )
}

export default MainCategoryProducts
